(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  class SeasonSection extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const signal = this.controller.signal;
      if (this.dataset.reveal === 'true' && !reduced() && !window.Shopify?.designMode && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.remove('gs-await'); entry.target.classList.add('gs-visible'); this.observer.unobserve(entry.target); }
        }), {threshold: .07});
        this.querySelectorAll('[data-gs-reveal]').forEach(el => { if (el.getBoundingClientRect().top > innerHeight - 30) { el.classList.add('gs-await'); this.observer.observe(el); } });
      }
      this.addEventListener('shopify:block:select', event => {
        const details = event.target.closest('details');
        if (details) details.open = true;
      }, {signal});
    }
    disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();}
  }
  class SeasonSlider extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController(); const signal=this.controller.signal;
      this.track=this.querySelector('.gs-slides');this.slides=[...this.querySelectorAll('.gs-slide')];this.tabs=[...this.querySelectorAll('[data-slide]')];this.index=0;this.elapsed=0;this.hovered=false;
      if(!this.track || !this.slides.length)return;
      this.duration=Number(this.dataset.interval||8)*1000;
      this.querySelector('[data-slider-controls]').hidden=this.slides.length<2;
      this.playing=this.dataset.autoplay==='true'&&!reduced()&&!window.Shopify?.designMode;
      this.querySelector('[data-pause]')?.addEventListener('click',()=>{this.playing=!this.playing;this.timerUpdate();},{signal});
      this.tabs.forEach(tab=>tab.addEventListener('click',()=>{this.playing=false;this.go(Number(tab.dataset.slide));},{signal}));
      this.track.addEventListener('keydown',event=>{
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.playing=false;this.go(this.index+(event.key==='ArrowRight'?1:-1));}
      },{signal});
      this.track.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.scrollFrame);this.scrollFrame=requestAnimationFrame(()=>{
          const index=Math.round(this.track.scrollLeft/this.track.clientWidth);
          if(index!==this.index){this.index=index;this.elapsed=0;this.paint();this.timerUpdate();}
        });
      },{passive:true,signal});
      this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){this.hovered=true;this.timerUpdate();}},{signal});
      this.addEventListener('pointerleave',()=>{this.hovered=false;this.timerUpdate();},{signal});
      this.addEventListener('focusin',event=>{if(!event.target.closest('[data-pause]')){this.playing=false;this.timerUpdate();}},{signal});
      this.track.addEventListener('pointerdown',()=>{this.playing=false;this.timerUpdate();},{signal});
      this.addEventListener('shopify:block:select',event=>{
        const i=this.slides.findIndex(slide=>slide===event.target||slide.contains(event.target));
        if(i>=0){this.playing=false;this.go(i);}
      },{signal});
      document.addEventListener('visibilitychange',()=>this.timerUpdate(),{signal});
      window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change',()=>{if(reduced())this.playing=false;this.timerUpdate();},{signal});
      this.dataset.ready='true';
      this.resize=new ResizeObserver(()=>{this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:'instant'});this.measureHeight();});this.resize.observe(this.track);this.slides.forEach(slide=>this.resize.observe(slide));
      this.paint();this.timerUpdate();
    }
    go(index){this.index=(index+this.slides.length)%this.slides.length;this.elapsed=0;this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:'instant'});this.paint();this.timerUpdate();}
    paint(){
      this.tabs.forEach((tab,i)=>tab.setAttribute('aria-current',String(i===this.index)));
      this.slides.forEach((slide,i)=>{slide.inert=i!==this.index;slide.setAttribute('aria-hidden',String(i!==this.index));});
      this.measureHeight();this.progress();
    }
    measureHeight(){const height=this.slides[this.index]?.getBoundingClientRect().height;if(height)this.style.setProperty('--gs-active-height',Math.ceil(height)+'px');}
    progress(){this.style.setProperty('--gs-slide-progress',(this.playing?Math.min(100,this.elapsed/this.duration*100):100)+'%');}
    timerUpdate(){
      cancelAnimationFrame(this.timer);this.lastTick=null;
      const pause=this.querySelector('[data-pause]');
      if(pause){pause.hidden=this.slides.length<2;pause.textContent=this.playing?'Pausa bildspelet':'Spela bildspelet';pause.setAttribute('aria-label',pause.textContent);}
      this.progress();
      if(!this.playing||this.hovered||document.hidden||reduced()||this.slides.length<2)return;
      const tick=now=>{
        if(this.lastTick!==null)this.elapsed+=now-this.lastTick;
        this.lastTick=now;this.progress();
        if(this.elapsed>=this.duration){this.go(this.index+1);return;}
        this.timer=requestAnimationFrame(tick);
      };
      this.timer=requestAnimationFrame(tick);
    }
    disconnectedCallback(){cancelAnimationFrame(this.timer);cancelAnimationFrame(this.scrollFrame);this.resize?.disconnect();this.controller?.abort();}
  }
  class SeasonRecipes extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
      this.track=this.querySelector('.gs-recipe-grid');this.cards=[...this.querySelectorAll('.gs-recipe')];
      this.controls=this.querySelector('[data-recipe-controls]');this.prev=this.querySelector('[data-recipe-prev]');this.next=this.querySelector('[data-recipe-next]');
      if(!this.track||!this.cards.length)return;
      this.prev.addEventListener('click',()=>this.move(-1),{signal});
      this.next.addEventListener('click',()=>this.move(1),{signal});
      this.track.addEventListener('pointerdown',()=>{this.destination=null;},{passive:true,signal});
      this.track.addEventListener('wheel',()=>{this.destination=null;},{passive:true,signal});
      this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.paint());},{passive:true,signal});
      this.track.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();
        const focused=this.cards.indexOf(event.target.closest('.gs-recipe'));
        if(focused>=0){
          const index=event.key==='Home'?0:event.key==='End'?this.cards.length-1:Math.max(0,Math.min(this.cards.length-1,focused+(event.key==='ArrowRight'?1:-1)));
          this.cards[index].focus({preventScroll:true});this.go(index);
        }else if(event.key==='Home')this.go(0);else if(event.key==='End')this.go(this.cards.length-1);else this.move(event.key==='ArrowRight'?1:-1);
      },{signal});
      this.addEventListener('shopify:block:select',event=>{const i=this.cards.findIndex(card=>card===event.target||card.contains(event.target));if(i>=0)this.go(i,true);},{signal});
      this.resize=new ResizeObserver(()=>{this.measure();this.go(this.index||0,true);});
      this.resize.observe(this.track);this.measure();this.paint();
    }
    measure(){
      this.maximum=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
      const first=this.cards[0].offsetLeft;
      this.positions=this.cards.map(card=>Math.min(this.maximum,card.offsetLeft-first));
      this.controls.hidden=this.maximum<2;
      const image=this.cards[0].querySelector('.gs-recipe-image');
      this.style.setProperty('--gs-recipe-arrow-top',(image.getBoundingClientRect().height/2)+'px');
    }
    paint(){
      if(this.destination!=null&&Math.abs(this.destination-this.track.scrollLeft)<2)this.destination=null;
      if(this.destination==null)this.index=this.positions.reduce((best,left,i)=>Math.abs(left-this.track.scrollLeft)<Math.abs(this.positions[best]-this.track.scrollLeft)?i:best,0);
      this.prev.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft>=this.maximum-2;
    }
    go(index,instant=false){
      this.index=Math.max(0,Math.min(this.cards.length-1,index));
      this.destination=this.positions[this.index];
      this.track.scrollTo({left:this.destination,behavior:instant||reduced()?'instant':'smooth'});
    }
    move(direction){
      const current=this.destination??this.track.scrollLeft;
      const target=direction>0?this.positions.findIndex(left=>left>current+2):this.positions.findLastIndex(left=>left<current-2);
      if(target>=0)this.go(target);
    }
    disconnectedCallback(){cancelAnimationFrame(this.frame);this.resize?.disconnect();this.controller?.abort();}
  }
  class SeasonProducts extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();
      const button=this.querySelector('[data-expand-products]');
      if(!button)return;
      const extra=[...this.querySelectorAll('[data-extra-product]')];
      extra.forEach(item=>item.hidden=true);button.hidden=extra.length===0;
      button.addEventListener('click',()=>{
        const next=extra.filter(item=>item.hidden).slice(0,24);
        next.forEach(item=>item.hidden=false);button.hidden=!extra.some(item=>item.hidden);
        if(button.hidden&&next.length)next[0].querySelector('a')?.focus({preventScroll:true});
      },{signal:this.controller.signal});
    }
    disconnectedCallback(){this.controller?.abort();}
  }
  class SeasonQuiz extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
      this.questions=[...this.querySelector('template[data-questions]').content.querySelectorAll('[data-question]')];
      if(!this.questions.length)return;
      this.index=0;this.answers=Array(this.questions.length).fill(null);this.locked=Array(this.questions.length).fill(false);
      this.panel=this.querySelector('[data-quiz-panel]');this.result=this.querySelector('[data-quiz-result]');this.questionSlot=this.querySelector('[data-question-slot]');
      this.panel.hidden=false;
      this.addEventListener('click',event=>{
        const button=event.target.closest('button');if(!button)return;
        if(button.hasAttribute('data-answer')&&!this.locked[this.index]){
          this.answers[this.index]=Number(button.dataset.answer);this.questionSlot.querySelectorAll('[data-answer]').forEach(answer=>answer.setAttribute('aria-pressed',String(answer===button)));
          this.querySelector('[data-check]').disabled=false;
        }
        if(button.hasAttribute('data-check'))this.check();
        if(button.hasAttribute('data-next-question')){if(this.index<this.questions.length-1){this.index++;this.render(true);}else this.finish();}
        if(button.hasAttribute('data-back-question')&&this.index>0){this.index--;this.render(true);}
        if(button.hasAttribute('data-restart')){this.index=0;this.answers.fill(null);this.locked.fill(false);this.result.hidden=true;this.panel.hidden=false;this.render(true);}
      },{signal});
      document.addEventListener('shopify:block:select',event=>{
        if(event.detail?.sectionId!==this.dataset.sectionId)return;
        const id=event.detail?.blockId;const i=this.questions.findIndex(q=>q.dataset.blockId===id);
        if(i>=0){this.index=i;this.result.hidden=true;this.panel.hidden=false;this.render(false);}
      },{signal});
      this.render(false);this.prizeState();
    }
    render(focus){
      this.questionSlot.replaceChildren(this.questions[this.index].cloneNode(true));
      this.querySelector('[data-count]').textContent='Fråga '+(this.index+1)+' av '+this.questions.length;
      const progress=this.querySelector('progress');progress.max=this.questions.length;progress.value=this.locked.filter(Boolean).length;
      this.querySelector('[data-back-question]').disabled=this.index===0;
      const check=this.querySelector('[data-check]'),next=this.querySelector('[data-next-question]');
      check.hidden=this.locked[this.index];check.disabled=this.answers[this.index]===null;next.hidden=!this.locked[this.index];next.querySelector('[data-next-label]').textContent=this.index===this.questions.length-1?'Se mitt resultat':'Nästa fråga';
      this.questionSlot.querySelectorAll('[data-answer]').forEach(btn=>{btn.setAttribute('aria-pressed',String(Number(btn.dataset.answer)===this.answers[this.index]));btn.disabled=this.locked[this.index];});
      if(this.locked[this.index])this.feedback();
      if(focus){const heading=this.questionSlot.querySelector('h3');heading.focus({preventScroll:true});heading.scrollIntoView({block:'start',behavior:reduced()?'instant':'smooth'});}
    }
    check(){if(this.answers[this.index]===null||this.locked[this.index])return;this.locked[this.index]=true;this.render(false);this.querySelector('[data-feedback]').focus({preventScroll:true});}
    feedback(){
      const right=Number(this.questions[this.index].dataset.correct)-1;
      const el=this.questionSlot.querySelector('[data-feedback]');el.hidden=false;
      el.querySelector('[data-verdict]').textContent=this.answers[this.index]===right?'Rätt!':'Inte riktigt. Rätt svar: '+this.questions[this.index].querySelector('[data-answer="'+right+'"] [data-answer-label]').textContent.trim();
    }
    finish(){
      if(!this.locked.every(Boolean))return;
      const score=this.answers.reduce((sum,answer,i)=>sum+(answer===Number(this.questions[i].dataset.correct)-1?1:0),0);
      this.panel.hidden=true;this.result.hidden=false;
      this.querySelector('[data-score]').textContent=score+' / '+this.questions.length;
      this.querySelector('[data-result-message]').textContent=score>=this.questions.length*.8?'Du har god känsla för långkok och ugn. Dags att låta kunskapen ta plats i köket!':score>=this.questions.length*.5?'Du har flera goda köksknep med dig. Nu har du också några nya att prova.':'Varje fråga är ett nytt köksknep. Ta med dig tipsen och prova något gott i helgen.';
      this.prizeState();const heading=this.result.querySelector('h3');heading.focus({preventScroll:true});heading.scrollIntoView({block:'start',behavior:reduced()?'instant':'smooth'});
    }
    prizeState(){
      const prize=this.querySelector('[data-prize]');if(!prize)return;
      const mode=prize.dataset.mode,start=Date.parse(prize.dataset.start),end=Date.parse(prize.dataset.end),now=Date.now();
      const link=prize.querySelector('[data-entry]'),status=prize.querySelector('[data-prize-status]');
      const configured=Number.isFinite(start)&&Number.isFinite(end)&&end>start&&link?.getAttribute('href')&&prize.querySelector('[data-terms]')?.getAttribute('href');
      if(link)link.hidden=true;
      if(mode==='knowledge'){prize.hidden=true;return;}
      prize.hidden=false;
      if(mode==='preview'){status.textContent='Exempel inför höstkampanjen. Utlottningen är inte öppen och inget deltagande registreras.';return;}
      if(!configured){status.textContent='Utlottningen är inte öppen ännu.';return;}
      if(now<start){status.textContent='Utlottningen öppnar '+new Date(start).toLocaleDateString('sv-SE')+'.';return;}
      if(now>end){status.textContent='Utlottningen är avslutad. Du kan fortfarande göra quizet och lära dig nya köksknep.';return;}
      status.textContent='Quizet är klart! För att delta behöver du även skicka in din anmälan. Öppet till '+new Date(end).toLocaleDateString('sv-SE')+'.';
      if(link)link.hidden=false;
    }
    disconnectedCallback(){this.controller?.abort();}
  }
  for(const [name,constructor] of [['gg-season-section',SeasonSection],['gg-season-slider',SeasonSlider],['gg-season-recipes',SeasonRecipes],['gg-season-products',SeasonProducts],['gg-season-quiz',SeasonQuiz]])if(!customElements.get(name))customElements.define(name,constructor);
})();
